import React from "react";
import styles from "../../../Meta.module.css";
import CloseIcon from "@mui/icons-material/Close";
import lockIcon from "../../../../../../../../assets/images/lock-border.svg";

function PaymentLinkGenerated(props: any) {
  const { cancelButtonClick, data } = props;
  return (
    <div>
      <div className={styles.addOnPopupHead}>
        <div className={styles.addOnPopupTitle}>
          <img src={lockIcon} alt="icon" />
        </div>
        <div className={styles.closeModalButton}>
          <CloseIcon
            sx={{ color: "#555555", cursor: "pointer" }}
            onClick={cancelButtonClick}
          />
        </div>
      </div>
      <div className={styles.payLinkBody}>
        <div className={styles.payLinkTitle}>Payment Link Generated</div>
        <div className={styles.payLinkSubTitle}>Verification Link</div>
        <a
          style={{
            wordBreak: "break-all",
            whiteSpace: "normal",
            overflowWrap: "break-word",
          }}
          className={styles.payLink}
          href={data?.data}
          target="_blank"
          rel="noopener noreferrer"
        >
          {data?.data}
        </a>
      </div>
    </div>
  );
}

export default PaymentLinkGenerated;
